"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDashes = exports.toCaseInsensitivePattern = exports.prefixesPattern = exports.patternToRegex = exports.escapeRegExp = exports.escapeParen = exports.WHITESPACE_REGEX = exports.NULL_REGEX = void 0;

// Escapes regex special chars
var escapeRegExp = function escapeRegExp(string) {
  return string.replace(/[\$\(-\+\.\?\[-\^\{-\}]/g, '\\$&');
};

exports.escapeRegExp = escapeRegExp;
var NULL_REGEX = /^(?!)/; // zero-width negative lookahead, matches nothing

exports.NULL_REGEX = NULL_REGEX;
var WHITESPACE_REGEX = new RegExp("([\\t-\\r \\xA0\\u1680\\u2000-\\u200A\\u2028\\u2029\\u202F\\u205F\\u3000\\uFEFF]+)", "y");
exports.WHITESPACE_REGEX = WHITESPACE_REGEX;

var patternToRegex = function patternToRegex(pattern) {
  return new RegExp("(?:".concat(pattern, ")"), 'uy');
}; // Converts "ab" to "[Aa][Bb]"


exports.patternToRegex = patternToRegex;

var toCaseInsensitivePattern = function toCaseInsensitivePattern(prefix) {
  return prefix.split('').map(function (_char) {
    return / /g.test(_char) ? '\\s+' : "[".concat(_char.toUpperCase()).concat(_char.toLowerCase(), "]");
  }).join('');
};
/** Escapes paren characters for RegExp patterns */


exports.toCaseInsensitivePattern = toCaseInsensitivePattern;

var escapeParen = function escapeParen(paren) {
  if (paren.length === 1) {
    // A single punctuation character
    return escapeRegExp(paren);
  } else {
    // longer word
    return '\\b' + paren + '\\b';
  }
};

exports.escapeParen = escapeParen;

var withDashes = function withDashes(pattern) {
  return pattern + '(?:-' + pattern + ')*';
}; // Converts ["a", "b"] to "(?:[Aa]|[Bb]|)" or "(?:[Aa]|[Bb])" when required = true


exports.withDashes = withDashes;

var prefixesPattern = function prefixesPattern(_ref) {
  var prefixes = _ref.prefixes,
      requirePrefix = _ref.requirePrefix;
  return "(?:".concat(prefixes.map(toCaseInsensitivePattern).join('|')).concat(requirePrefix ? '' : '|', ")");
};

exports.prefixesPattern = prefixesPattern;
//# sourceMappingURL=regexUtil.js.map